import { DefaultButton } from 'components/button/DefaultButton';
import { TextInput } from 'components/forms/TextInput';
import { ValidatableLabel } from 'components/forms/ValidatableLabel';
import { LoginFooter, LoginForm } from 'pages/Login/Login';
import { sdUserEmailRules, userEmailMaxLength } from 'pages/Login/shared';
import * as React from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';

export type EmailScreenProps = {
    register: UseFormRegister<LoginForm>;
    emailErrors: FieldError | undefined;
    onLogin: () => void;
    onSubmit: (event: React.FormEvent) => void;
    actionable: boolean;
};

export function EmailScreen({
    register,
    emailErrors,
    onLogin,
    onSubmit,
    actionable,
}: EmailScreenProps) {
    return (
        <form onSubmit={onSubmit} noValidate>
            <ValidatableLabel label="Email Address" className="mb-10" error={emailErrors}>
                <TextInput
                    type="email"
                    placeholder="sd-user@company.com"
                    autofocus
                    className="my-5"
                    invalid={emailErrors !== undefined}
                    maxLength={userEmailMaxLength}
                    {...register('email', sdUserEmailRules)}
                />
            </ValidatableLabel>
            <LoginFooter>
                <div className="flex-grow-1" />
                <DefaultButton
                    type="button"
                    onClick={onLogin}
                    disabled={!actionable}
                    aria-label="Log In"
                >
                    Log In
                </DefaultButton>
            </LoginFooter>
        </form>
    );
}
